import { createApp } from 'petite-vue'

const productsFilter = createApp( {
  selectedApplication: 'all',
  selectedIndustry: 'all',
  selectedType: 'all',
  productsFound: true,
  updateFilter( type: string, event: Event ) {
    if ( type === 'type' ) {
      this.selectedType = ( event.target as HTMLSelectElement ).value
    }
    if ( type === 'application' ) {
      this.selectedApplication = ( event.target as HTMLSelectElement ).value
    }
    if ( type === 'industry' ) {
      this.selectedIndustry = ( event.target as HTMLSelectElement ).value
    }
    console.log( this.selectedType, this.selectedApplication, this.selectedIndustry )
    const products = document.querySelectorAll<HTMLLIElement>( '.products-list .single-product' )
    this.productsFound = false
    products.forEach( product => {
      product.style.display = 'none'
      const productsToShow = this.selectedType === 'all' || product.dataset.productTypes?.includes( this.selectedType )
      const applicationsToShow = this.selectedApplication === 'all' || product.dataset.productApplications?.includes( this.selectedApplication )
      const industriesToShow = this.selectedIndustry === 'all' || product.dataset.productIndustries?.includes( this.selectedIndustry )
      if ( productsToShow && applicationsToShow && industriesToShow ) {
        console.log( 'found match', product )
        product.style.display = 'block'
        this.productsFound = true
      }
    } )
  }
} )

export default productsFilter